import { global_divider } from '../../utils/requests/contentstack/contentStackZodSchema';
import { type DividerProps } from './Divider';

export const dividerSchema = global_divider.transform<DividerProps>(data => ({
  variant: data.variant,
}));
